<template>
  <div class="form-group">
    <label v-if="label" :for="id">{{ this.label }}</label>
    <vue-autosuggest
        :id="id"
        :ref="$id('autocomplete')"
        :limit="10"
        :suggestions="suggestions"
        :inputProps="inputProps"
        :getSuggestionValue="getSuggestionValue"
        @selected="selectResult"
        @input="fetchResults"
        :value="value"
    >
      <template slot-scope="{suggestion}">
        <li class="item">{{ suggestion.item.item }}</li>
      </template>
    </vue-autosuggest>
  </div>
</template>
<script>

export default {
  name: "AutoCompleteTextEdit",
  props: {
    id: String,
    name: String,
    placeholder: String,
    label: String,
    url: String,
    value: String,
    maxResults: Number,
    index: Number,
    options: Object,
  },
  data: function () {
    return {
      currentValue: this.value,
      maxResultsCalc: this.maxResults,
      timeout: null,
      suggestions: [],
      inputProps: {
        id: "autosuggest__input",
        name: this.name,
        placeholder: this.placeholder,
        class: "form-control",
      },
    }
  },
  created: function () {
    if (this.maxResultsCalc == null) {
      this.maxResultsCalc = 20;
    }
  },
  methods: {
    fetchResults: function (val) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        axios.post(this.url, {
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          },
          query: val,
          options: this.options,
          maxResults: this.maxResultsCalc,
        }).then(values => {
          this.suggestions = [];
          this.selected = null;

          let query = values.data.query;
          let artikel = values.data.results;

          console.log(query, artikel);

          artikel.length && this.suggestions.push({name: "artikel", data: artikel});

        })
      }, 50);
    },
    selectResult: function (result) {
      this.currentValue = this.getSuggestionValue(result);
    },
    getSuggestionValue(suggestion) {
      let {name, item} = suggestion;
      return item.item;
    },
  },
  watch: {
    currentValue: function (newValue, oldValue) {
      this.$emit('newValue', newValue, this.index);
    }
  }

}
</script>

<style scoped>
.autocompleteList {
  z-index: 10000 !important;
  position: absolute;
}
</style>